import { Component, Input, OnInit } from '@angular/core';
import { CustomFlexLayoutModule } from '../../../flex-layout/custom-flex-layout.module';
import { MatButtonModule } from '@angular/material/button';
import { NgFor } from '@angular/common';
import { EditorTextComponent } from '../editor-text/editor-text.component';

@Component({
  selector: 'calsoft-comparison',
  imports: [CustomFlexLayoutModule ,MatButtonModule,NgFor,EditorTextComponent],
  templateUrl: './comparison.component.html',
  styleUrl: './comparison.component.scss'
})
export class ComparisonComponent implements OnInit {
  @Input() data : any ;
  @Input() img: any ;

  @Input() item: any ;

  leftArray: any[] = [];
  rightArray: any[] = [];

  ngOnInit(): void {
    const leftSize = this.item?.customField39 || 3;
    const rightSize = this.item?.customField40 || 2;

    this.leftArray = this.img.slice(0, leftSize);
    this.rightArray = this.img.slice(leftSize, leftSize + rightSize);
  }
}
